import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from './../../shared/components/searchForm/SearchForm';
import DataTable from './../../shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';
import { interfaceSearchFields } from "../utils/searchFields";
import { appModules } from '../../roles/components/UserHasPermission';

const InterfacesPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    handleAddButtonClicked,
    data = [],
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    categoryList,
    unitTypeList,
    entityList,
    suppressSearchForm = false,
    sort: {
        property = "",
        direction = "ASC"
    },
    onPageChange,
    onPageSizeChange,
}) => {
    const columns = [{
        Header: I18n.t("interfaces.list.interfaceId"),
        accessor: "interfaceIdentifier",
        sortable: true
    }, {
        Header: I18n.t("interfaces.list.name"),
        accessor: "name",
        sortable: true
    }, {
        Header: I18n.t("interfaces.list.dataType"),
        accessor: "dataType",
        sortable: true
    }, {
        Header: I18n.t("interfaces.list.category"),
        id: "category",
        accessor: interfaceInstance => interfaceInstance.category.value,
        sortable: true
    }, {
        Header: I18n.t("interfaces.list.historyConfiguration"),
        accessor: "historyConfiguration",
        sortable: true
    }, {
        Header: I18n.t("interfaces.list.lastReading"),
        accessor: "lastReading",
        sortable: false
    }, {
        Header: I18n.t("interfaces.list.lastCommunication"),
        accessor: "lastCommunicationTimestamp",
        sortable: true
    }];
    return <div className="page_background">
        {!suppressSearchForm &&
            <SearchForm
                content={interfaceSearchFields(searchFieldsValues, categoryList, unitTypeList, entityList)}
                universalSearchField={universalSearchField}
                handleFieldChange={handleSearchFieldChange}
                handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
                handleClear={handleSearchClear}
                handleSubmit={handleSearchSubmit}
                handleAddButtonClicked={handleAddButtonClicked}
                appModule={appModules.INTERFACE}
            />}
        <div>
            <DataTable
                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={columns}
                hasStatusBar={false}
            />
        </div>
    </div>
}

InterfacesPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
}

export default InterfacesPage;